import React, { useState, useEffect } from "react";
import logo from "../Untitled.svg";
import { useGlobalContext } from "../context";
import { FaPhone, FaTimes } from "react-icons/fa";
import { social, Links } from "../Data";
import {  } from "react-icons/fa";

const Sidebar = () => {
	const { isSidebarOpen, closeSidebar } = useGlobalContext();

	return (
		<aside className={`${isSidebarOpen ? "sidebar show-sidebar" : "sidebar"}`}>
			<div className="sidebar-header">
				<img src={logo} className="logo" alt="coding addict" />
				<button className="close-btn" onClick={closeSidebar}>
					<FaTimes />
				</button>
			</div>
			<ul className="sideLinks">
				{Links.map((link) => {
					const { id, url, name, icon } = link;
					return (
						<li key={id} onClick={closeSidebar}>
							<a href={url}>
								{icon}
								{name}
							</a>
						</li>
					);
				})}
				<li onClick={closeSidebar}>
					<a href="#contact">
						<FaPhone /> contact
					</a>
				</li>
			</ul>
			<ul className="social-icons">
				{social.map((link) => {
					const { id, url, icon } = link;
					return (
						<li key={id}>
							<a href={url} target='_blank'>{icon}</a>
						</li>
					);
				})}
			</ul>
		</aside>
	);
};

export default Sidebar;
